var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};


OCS.WxBriefing.Classes.UrlManager = new Class({
    Implements: [OCS.WxBriefing.Classes.SingletonManager],
    manager_name: 'UrlManager',
    allow_url_changes: true,
    current_url_state: null,
    debug: false,
    future_url_state: null,
    future_url_remove_state: false,
    url_change_timeout: null,
    url_merge_mode: 2, // 0: params in the params argument will override any params in the current state.
    // 1: any params in the current state will override params in the params argument.
    // 2: params argument will completely replace current state.
    options: {
        url_state_change_event: "url_state_change",
        url_pending_state_change_event: "url_pending_state_change",
        time_to_url_change: 750
    },
    bound_methods: {},
    init: function (op) {
        this.setOptions(op);
        this.bound_methods.on_hash_change = this.on_hash_change.bind(this);
        this.bound_methods.update_url_state = this.update_url_state.bind(this);
        this.bound_methods.on_menu_available = this.on_menu_available.bind(this);
        document.id(window).addEvent('hashchange', this.bound_methods.on_hash_change);
        this.current_url_state = $.bbq.getState();
        if (!this.current_url_state || Object.keys(this.current_url_state).length < 2) {
            var default_config = this.get_default_config();
            if (default_config) {
                this.update_url_state(default_config, 0);
                this.current_url_state = $.bbq.getState();
            }
        }
    },
    update_url_state: function (deltas, url_change_timeout_time) {
        if (this.url_change_timeout) {
            clearTimeout(this.url_change_timeout);
            this.url_change_timeout = null;
        }
        if (url_change_timeout_time === undefined || url_change_timeout_time === null) {
            url_change_timeout_time = this.options.time_to_url_change;
        }
        if (OCS.Utilities.is_string(deltas)) {
            deltas = deltas.replace(/%5B/g, '[').replace(/%5D/g, ']');
        }
        if (!OCS.Utilities.is_string(deltas)) {
            // Apply deltas to current state, remove a key by passing the key with a value of null 
            if (this.future_url_state) {
                this.future_url_state = OCS.Utilities.combine_objects(this.future_url_state, deltas, {merge: true, deep: true, remove: true, merge_mismatch: true});
            } else {
                this.future_url_state = OCS.Utilities.combine_objects(this.current_url_state, deltas, {merge: true, deep: true, remove: true, merge_mismatch: true});
            }
            this.url_change_timeout = setTimeout(this.on_update_url_timeout.bind(this), url_change_timeout_time);
        } else {
            $.bbq.pushState(deltas, 2);
        }
        this.fireEvent(this.options.url_pending_state_change_event, deltas);
    },
    on_update_url_timeout: function () {
        if (this.url_change_timeout) {
            clearTimeout(this.url_change_timeout);
            this.url_change_timeout = null;
        }
        if (this.allow_url_changes) {
            $.bbq.pushState(this.future_url_state, this.url_merge_mode);
            this.future_url_state = null;
        } else {
            this.url_change_timeout = setTimeout(this.on_update_url_timeout.bind(this), this.options.time_to_url_change);
        }
    },
    on_menu_available: function () {
        var menu = OCS.WxBriefing.Functions.get_ui_menu();
        menu.removeEvent('menu_available', this.bound_methods.on_menu_available);
        if (!this.current_url_state || Object.keys(this.current_url_state).length < 2) {
            var default_config = this.get_default_config();
            if (default_config) {
                this.update_url_state(default_config, 0);
            }
        }
    },
    on_hash_change: function (event) {
        var old_state = this.current_url_state;
        var new_state;
        try {
            new_state = $.bbq.getState();
        } catch (err) {
            new_state = old_state;
            console.warn("UrlManager: Failed to load url state.", err);
        }
        // Compare new state versus the current state
        if (!OCS.Utilities.is_object_equal(old_state, new_state)) {
            this.current_url_state = new_state;
            this.fireEvent(this.options.url_state_change_event, [new_state, old_state, this]);
        }
    },
    get_default_config: function () {
        var menu = OCS.WxBriefing.Functions.get_ui_menu();
        var config = menu.get_default_config();
        if (config) {
            return config;
        } else {
            // No default provided, lets update when the menu becomes available
            if (!menu.menu_available) {
                menu.addEvent('menu_available', this.bound_methods.on_menu_available);
            } else {
                alert('There was an error with loading the page. Please refresh your browser and try again.');
            }

            return false;
        }
    },
    destroy: function () {
        if (this.url_change_timeout) {
            clearTimeout(this.url_change_timeout);
            this.url_change_timeout = null;
        }
        this.current_url_state = null;
        this.removeEvents();
        document.id(window).removeEvent('hashchange', this.bound_methods.on_hash_change);
    }
});
